export interface SelectOption {
  id: string;
  esValue: string;
}

export function selectOptionActions() {
  function create(id: string, esValue: string): SelectOption {
    return {
      id: id,
      esValue: esValue,
    };
  }

  return {
    create,
  };
}
